// extracted by mini-css-extract-plugin
var _1 = "SmKSaiokqpXoaCKviwJ6";
export { _1 as "wrapper" }
